import React, { useEffect, useState } from 'react'
import { I18n } from 'react-redux-i18n'
import ReactSwitch from 'react-switch'

import { Button, SelectWithLabel } from 'components/Form'
import TextInputField from 'components/Form/TextInputField'
import ModalWrapper from 'components/ModalWrapper'
import ImapValidationModal from './ImapVerificationModal'
import { channels } from 'api'
import './styles.scss'

const _ = require('lodash')
const lang = (text) => I18n.t(text)

const ImapModal = (props) => {
  const { mailProvider, isOpenModalNormal, toggle, onSubmit, onChange: onChangeExternal, schema, channel: { value } } = props
  const [ state, setState ] = useState({ password: '', email: '', timeFrame: '', isEqualImapSmtp: true, imap: { user: "", password: "", host: "", port: "", tls: false }, smtp: { user: "", password: "", host: "", port: "", tls: false } })
  const [ stateError, setStateError ] = useState({ password: '', email: '', timeFrame: '', imap: { user: "", password: "", host: "", port: "" }, smtp: { user: "", password: "", host: "", port: "" } })
  const [ isSubmitting, setIsSubmitting ] = useState(false)
  const [ isImapVerified, setIsImapVerified ] = useState(false)
  const [ isOpenVerificationModal, setIsOpenVerificationModal ] = useState(false)
  const [ typeMessage, setTypeMessage ] = useState('')
  const [ changes, setChanges ] = useState({ imap: [], smtp: [] })
  const [ manualConfig, setManualConfig ] = useState(false)

  const errorRequiredField = I18n.t('dashboard_errors_required-field')
  const optionsTimeFrame = schema?.schema?.timeFrame?.options.map(it => ({ value: it.value, label: I18n.t(it.label) })) || []
  const TYPE_MESSAGES = {
    INIT: 'init',
    SUCCESS: 'success',
    CHANGES: 'changes',
    ERROR: 'error',
    AUTOCONFIG_ERROR: 'autoconfig_error'
  }

  useEffect(() => {
    if (value) {
      let _state = _.clone(state)
      if (value?.email) _.set(_state, 'email', value.email)
      if (value?.password) _.set(_state, 'password', value.password)
      if (value?.timeFrame) _.set(_state, 'timeFrame', value.timeFrame)
      if (value?.imap?.host) _.set(_state, 'imap.host', value.imap.host)
      if (value?.imap?.port) _.set(_state, 'imap.port', value.imap.port)
      if (value?.imap?.user) _.set(_state, 'imap.user', value.imap.user)
      if (value?.imap?.password) _.set(_state, 'imap.password', value.imap.password)
      if (value?.imap?.tls) _.set(_state, 'imap.tls', value.imap.tls)
      if (value?.smtp?.host) _.set(_state, 'smtp.host', value.smtp.host)
      if (value?.smtp?.port) _.set(_state, 'smtp.port', value.smtp.port)
      if (value?.smtp?.user) _.set(_state, 'smtp.user', value.smtp.user)
      if (value?.smtp?.password) _.set(_state, 'smtp.password', value.smtp.password)
      if (value?.smtp?.tls) _.set(_state, 'smtp.tls', value.smtp.tls)
      if (value?.isEqualImapSmtp) _.set(_state, 'isEqualImapSmtp', value.isEqualImapSmtp)
      setState(_state)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  useEffect(() => {
    let _stateError = _.clone(stateError)
    if (state?.email) _.set(_stateError, 'email', '')
    if (state?.password) _.set(_stateError, 'password', '')
    if (state?.timeFrame) _.set(_stateError, 'timeFrame', '')
    if (state.imap.host) _.set(_stateError, 'imap.host', '')
    if (state.imap.port) _.set(_stateError, 'imap.port', '')
    if (state.imap.user) _.set(_stateError, 'imap.user', '')
    if (state.imap.password) _.set(_stateError, 'imap.password', '')
    if (state.smtp.host) _.set(_stateError, 'smtp.host', '')
    if (state.smtp.port) _.set(_stateError, 'smtp.port', '')
    if (state.smtp.user) _.set(_stateError, 'smtp.user', '')
    if (state.smtp.password) _.set(_stateError, 'smtp.password', '')

    setStateError(_stateError)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state])

  const validateFields = ({ manualConfig }) => {
    let error = false

    let _stateError = _.clone(stateError)

    if (manualConfig) {
      if (!state.email) {
        _.set(_stateError, 'email', errorRequiredField)
        error = true
      }

      if (!state.imap.host) {
        _.set(_stateError, 'imap.host', errorRequiredField)
        error = true
      }
      if (!state.imap.port) {
        _.set(_stateError, 'imap.port', errorRequiredField)
        error = true
      }
      if (!state.smtp.host) {
        _.set(_stateError, 'smtp.host', errorRequiredField)
        error = true
      }
      if (!state.smtp.port) {
        _.set(_stateError, 'smtp.port', errorRequiredField)
        error = true
      }
      if (!state.isEqualImapSmtp) {
        if (!state.imap.user) {
          _.set(_stateError, 'imap.user', errorRequiredField)
          error = true
        }
        if (!state.imap.password) {
          _.set(_stateError, 'imap.password', errorRequiredField)
          error = true
        }
        if (!state.smtp.user) {
          _.set(_stateError, 'smtp.user', errorRequiredField)
          error = true
        }
        if (!state.smtp.password) {
          _.set(_stateError, 'smtp.password', errorRequiredField)
          error = true
        }
      } else {
        if (!state.password) {
          _.set(_stateError, 'password', errorRequiredField)
          error = true
        }
      }
    } else {
      if (!state.email) {
        _.set(_stateError, 'email', errorRequiredField)
        error = true
      }

      if (!state.password) {
        _.set(_stateError, 'password', errorRequiredField)
        error = true
      }
    }

    if (!state.timeFrame) {
      _.set(_stateError, 'timeFrame', errorRequiredField)
      error = true
    }

    if (error) {
      setStateError(_stateError)
    }

    return error
  }

  const onSave = async () => {
    const error = validateFields({ manualConfig })

    if (error) return

    setIsSubmitting(true)
    try {
      props.channel.value = state
      const result = await onSubmit()
      setIsSubmitting(false)
      if (result?._id) {
        toggle()
      }
    } catch (error) {
      setIsSubmitting(false)
    }
  }

  const onChange = (field, value) => {
    const _state = _.clone(state)
    _.set(_state, field, value)

    if (state.isEqualImapSmtp) {
      if (field === 'email') {
        _.set(_state, 'imap.user', value)
        _.set(_state, 'smtp.user', value)
      }
      if (field === 'password') {
        _.set(_state, 'imap.password', value)
        _.set(_state, 'smtp.password', value)
      }
    }

    if (field === 'isEqualImapSmtp') {
      if (state.isEqualImapSmtp) {
        _state.imap.user = state.email
        _state.smtp.user = state.email

        _state.imap.password = state.password
        _state.smtp.password = state.password
      }

      if (value) {
        setState({ ..._state, password: '', imap: { user: state.email || "", password: state.password || "", host: "", port: "", tls: false }, smtp: { user: state.email || "", password: state.password || "", host: "", port: "", tls: false } })
      } else setState({ ..._state, password: '', imap: { user: "", password: "", host: "", port: "", tls: false }, smtp: { user: "", password: "", host: "", port: "", tls: false } })
      return
    }

    if (field === 'manualConfig') {
      setManualConfig(value)
      setState({ ..._state, isEqualImapSmtp: true })
      cleanErrorState()
      return
    }

    setState(_state)
    setStateError({ ...stateError, imap: { user: "", password: "", host: "", port: "", tls: "", sendVerificationError: "" }, smtp: { user: "", password: "", host: "", port: "", tls: "", sendVerificationError: "" }, })
    if (field !== 'timeFrame' ) setIsImapVerified(false)
    onChangeExternal(_state)
  }

  const closeModal = () => {
    setState({ password: '', email: '', timeFrame: '', isEqualImapSmtp: false, imap: { user: "", password: "", host: "", port: "", tls: false }, smtp: { user: "", password: "", host: "", port: "", tls: false } })
    setStateError({ password: '', email: '', timeFrame: '', imap: { user: "", password: "", host: "", port: "" }, smtp: { user: "", password: "", host: "", port: "" } })
    setManualConfig(false)
    toggle()
  }

  const cleanState = () => {
    setState({
      password: '',
      email: state.email,
      timeFrame: state.timeFrame,
      isEqualImapSmtp: false,
      imap: {
        user: state.email || state.imap.user,
        password: '',
        host: "",
        port: "",
        tls: false
      },
      smtp: {
        user: state.email || state.smtp.user,
        password: '',
        host: "",
        port: "",
        tls: false
      }
    })
  }

  const cleanErrorState = () => {
    setStateError({ ...stateError, imap: { user: "", password: "", host: "", port: "", tls: "", sendVerificationError: "" }, smtp: { user: "", password: "", host: "", port: "", tls: "", sendVerificationError: "" }, })
  }

  const applyChanges = ({ rejecChanges = true }) => {
    if (rejecChanges) return

    setIsSubmitting(true)

    const _state = _.clone(state)
    const imapChanges = _.get(changes, 'imap')
    const smtpChanges = _.get(changes, 'smtp')

    if (imapChanges && imapChanges.length) {
      for(const imapChange of imapChanges) {
        _.set(_state, `imap.${imapChange.field}`, imapChange.field === 'tls' ? (imapChange.current === 'true') : imapChange.current)
      }
    }

    if (smtpChanges && smtpChanges.length) {
      for(const smtpChange of smtpChanges) {
        _.set(_state, `smtp.${smtpChange.field}`, smtpChange.field === 'tls' ? (smtpChange.current === 'true') : smtpChange.current)
      }
    }

    if (state.isEqualImapSmtp) {
      _state.imap.user = state.email
      _state.smtp.user = state.email

      _state.imap.password = state.password
      _state.smtp.password = state.password
    }

    setIsImapVerified(true)
    setState({ ...state, ..._state })

    onSave()
  }

  const applyAutoconfig = (autoconfig) => {
    const _state = _.clone(state)
    const imapConfig = _.get(autoconfig, 'imap.autoconfig')
    const smtpConfig = _.get(autoconfig, 'smtp.autoconfig')

    _.set(_state, 'imap', imapConfig)
    _.set(_state, 'smtp', smtpConfig)

    setIsImapVerified(true)
    setState({ ...state, ..._state })
  }

  const validateImap = async () => {
    const error = validateFields({ manualConfig })

    if (error) return
    setTypeMessage(TYPE_MESSAGES.INIT)
    setIsOpenVerificationModal(true)
    setIsSubmitting(true)
    try {
      let config = {
        imap: {
          host: state.imap.host,
          user: state.imap.user,
          password: state.imap.password,
          port: state.imap.port,
          tls: state.imap.tls
        },
        smtp: {
          host: state.smtp.host,
          user: state.smtp.user,
          password: state.smtp.password,
          port: state.smtp.port,
          tls: state.smtp.tls
        }
      }

      if (state.isEqualImapSmtp) {
        config.imap.user = state.email
        config.smtp.user = state.email

        config.imap.password = state.password
        config.smtp.password = state.password
      }

      if (!manualConfig) {
        config = {
          autoconfig: {
            user: state.email,
            password: state.password
          }
        }
      }

      const { data } = await channels.imapVerification(config)

      const result = [_.get(data, 'imap.success'), _.get(data, 'smtp.success')].every(config => config)

      if (result) {
        setIsSubmitting(false)
        setIsImapVerified(true)
        setTypeMessage(TYPE_MESSAGES.SUCCESS)
        if (!manualConfig) applyAutoconfig(data)
      } else {
        const imapChanges = _.get(data, 'imap.changes') || null
        const smtpChanges = _.get(data, 'smtp.changes') || null
        const imapErrors = _.get(data, 'imap.error') || null
        const smtpErrors = _.get(data, 'smtp.error') || null

        let _stateError = _.clone(stateError)
        if (imapErrors || smtpErrors) {
          setTypeMessage(TYPE_MESSAGES.ERROR)

          if ([imapErrors?.type, smtpErrors?.type].some(type => type === 'autoconfig_not_found')) {
            setTypeMessage(TYPE_MESSAGES.AUTOCONFIG_ERROR)
            cleanState()
            setManualConfig(true)
          }
          if (imapErrors) _.set(_stateError, 'imap.sendVerificationError', imapErrors.type)
          if (smtpErrors) _.set(_stateError, 'smtp.sendVerificationError', smtpErrors.type)
        } else if (imapChanges || smtpChanges) {
          setTypeMessage(TYPE_MESSAGES.CHANGES)

          const _changes = _.clone(changes)

          if (imapChanges && Object.keys(imapChanges).length) {
            for(const key in imapChanges) {
              if (key === 'port') _changes.imap.push({ field: key, msg: 'imap_change_port', current: imapChanges[key], previous: state.imap.port })
              if (key === 'tls') {
                const currentLabel = imapChanges[key].toString() === 'true' ? 'dashboard_activated' : 'dashboard_disabled'
                const previousLabel = state.imap.tls.toString() === 'true' ? 'dashboard_activated' : 'dashboard_disabled'
                _changes.imap.push({
                  field: key,
                  msg: 'imap_change_tls',
                  currentLabel,
                  current: imapChanges[key].toString(),
                  previousLabel,
                  previous: state.imap.tls.toString()
                })
              }
            }
          }

          if (smtpChanges && Object.keys(smtpChanges).length) {
            for(const key in smtpChanges) {
              if (key === 'port') _changes.smtp.push({ field: key, msg: 'smtp_change_port', current: smtpChanges[key], previous: state.smtp.port })
              if (key === 'tls') {
                const currentLabel = smtpChanges[key].toString() === 'true' ? 'dashboard_activated' : 'dashboard_disabled'
                const previousLabel = state.smtp.tls.toString() === 'true' ? 'dashboard_activated' : 'dashboard_disabled'
                _changes.smtp.push({
                  field: key,
                  msg: 'smtp_change_tls',
                  currentLabel,
                  current: smtpChanges[key].toString(),
                  previousLabel,
                  previous: state.smtp.tls.toString()
                })
              }
            }
          }

          setChanges(_changes)
        }

        setStateError(_stateError)
        setIsSubmitting(false)
      }

    } catch(error) {
      if (error)
        console.error(error)
    }
  }

  return (
    <>
      <ModalWrapper
        id={'modalAccountImap'}
        header={lang('dashboard_new-account')}
        body={
          mailProvider
            ?
            <div className='imap-wrapper'>
              <h2>{lang('channels_config_email_provider')}</h2>
              <div className='imap-seccion-one'>
                <TextInputField
                  label={lang('dashboard_email')}
                  value={state.email}
                  placeholder={lang('channels_field_email_placeholder')}
                  onChange={(value) => onChange('email', value.replace(/\s/g, ''))}
                  errorMessage={stateError.email}
                />
                {
                  state.isEqualImapSmtp
                    ?
                    <TextInputField
                      label={lang('dashboard_password')}
                      value={state.password}
                      placeholder='********'
                      onChange={(value) => onChange('password', value)}
                      type='password'
                      errorMessage={stateError.password}
                    />
                    :
                    null
                }

              </div>

              <div className={`imap-seccion-one-config ${!manualConfig ? 'autoconfig' : ''}`}>
                <div className='delegate-select-wrapper'>
                  <label className='label-select'>{lang('dashboard_import')}</label>
                  <SelectWithLabel
                    placeholder={lang('dashboard_select')}
                    options={optionsTimeFrame}
                    onChange={(value) => onChange('timeFrame', value.value)}
                    value={optionsTimeFrame.find(it => it.value === state.timeFrame) || ''}
                  />
                  {stateError?.timeFrame && <span className='error-message'>{stateError?.timeFrame}</span>}
                </div>

                <div className='field-switch'>
                  <ReactSwitch
                    id='isManualConfig'
                    checked={manualConfig}
                    onChange={(value) => onChange('manualConfig', value)}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    width={50}
                    height={25}
                    onColor='#E87721'
                    onHandleColor='#fff'
                  />
                  <label>{lang('dashboard_manual-configuration')}</label>
                </div>
              </div>

              {
                manualConfig && <div className='imap-seccion-two'>
                  <div className='field-switch'>
                    <ReactSwitch
                      id='isEqualImapSmtp'
                      checked={state.isEqualImapSmtp}
                      onChange={(value) => onChange('isEqualImapSmtp', value)}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      width={50}
                      height={25}
                      onColor='#E87721'
                      onHandleColor='#fff'
                    />
                    <label>{lang('channels_field_isEqualImapSmtp')}</label>
                  </div>

                  {
                    !state?.isEqualImapSmtp
                      ?
                      <>
                        <div className='imap-seccion-three'>
                          <h3>{lang('channels_field_imap_host')}</h3>
                          <div className='imap-seccion-input-one'>
                            <TextInputField
                              label={lang('dashboard_username')}
                              value={state.imap.user}
                              placeholder={lang('channels_field_email_placeholder')}
                              onChange={(value) => onChange('imap.user', value.replace(/\s/g, ''))}
                              errorMessage={stateError.imap.user}
                            />

                            <TextInputField
                              label={lang('dashboard_password')}
                              value={state.imap.password}
                              placeholder={'********'}
                              onChange={(value) => onChange('imap.password', value)}
                              type='password'
                              errorMessage={stateError.imap.password}
                            />
                          </div>
                          <div className='imap-seccion-input-two'>
                            <TextInputField
                              label={lang('dashboard_imap-server')}
                              value={state.imap.host}
                              placeholder={lang('channels_field_imap_host_placeholder')}
                              onChange={(value) => onChange('imap.host', value.replace(/\s/g, ''))}
                              errorMessage={stateError.imap.host}
                            />

                            <TextInputField
                              label={lang('channels_field_port')}
                              value={state.imap.port}
                              placeholder={lang('channels_field_imap_port_placeholder')}
                              onChange={(value) => onChange('imap.port', value.replace(/\s/g, ''))}
                              type='number'
                              errorMessage={stateError.imap.port}
                            />
                          </div>
                          <div className='field-switch'>
                            <ReactSwitch
                              checked={state.imap.tls}
                              onChange={(value) => onChange('imap.tls', value)}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              width={50}
                              height={25}
                              onColor='#E87721'
                              onHandleColor='#fff'
                            />
                            <label>{lang('channels_field_tls')}</label>
                          </div>
                        </div>
                        <div className='imap-seccion-four'>
                          <h3>{lang('channels_field_smtp_host')}</h3>
                          <div className='imap-seccion-input-one'>
                            <TextInputField
                              label={lang('dashboard_username')}
                              value={state.smtp.user}
                              placeholder={lang('channels_field_email_placeholder')}
                              onChange={(value) => onChange('smtp.user', value.replace(/\s/g, ''))}
                              errorMessage={stateError.smtp.user}
                            />

                            <TextInputField
                              label={lang('dashboard_password')}
                              value={state.smtp.password}
                              placeholder={'********'}
                              onChange={(value) => onChange('smtp.password', value)}
                              type='password'
                              errorMessage={stateError.smtp.password}
                            />
                          </div>
                          <div className='imap-seccion-input-two'>
                            <TextInputField
                              label={lang('channels_field_smtp_host')}
                              value={state.smtp.host}
                              placeholder={lang('channels_field_smtp_host_placeholder')}
                              onChange={(value) => onChange('smtp.host', value.replace(/\s/g, ''))}
                              errorMessage={stateError.smtp.host}
                            />

                            <TextInputField
                              label={lang('channels_field_port')}
                              value={state.smtp.port}
                              placeholder={lang('channels_field_smtp_port_placeholder')}
                              onChange={(value) => onChange('smtp.port', value.replace(/\s/g, ''))}
                              type='number'
                              errorMessage={stateError.smtp.port}
                            />
                          </div>
                          <div className='field-switch'>
                            <ReactSwitch
                              checked={state.smtp.tls}
                              onChange={(value) => onChange('smtp.tls', value)}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              width={50}
                              height={25}
                              onColor='#E87721'
                              onHandleColor='#fff'
                            />
                            <label>{lang('channels_field_tls')}</label>
                          </div>
                        </div>
                      </>
                      :
                      <div className='imap-seccion-four'>
                        <div className='imap-seccion-input-two'>
                          <TextInputField
                            label={lang('channels_field_imap_host')}
                            value={state.imap.host}
                            placeholder={lang('channels_field_imap_host_placeholder')}
                            onChange={(value) => onChange('imap.host', value.replace(/\s/g, ''))}
                            errorMessage={stateError.imap.host}
                          />
                          <TextInputField
                            label={lang('channels_field_port')}
                            value={state.imap.port}
                            placeholder={lang('channels_field_imap_port_placeholder')}
                            onChange={(value) => onChange('imap.port', value.replace(/\s/g, ''))}
                            type='number'
                            errorMessage={stateError.imap.port}
                          />
                        </div>
                        <div className='field-switch'>
                          <ReactSwitch
                            checked={state.imap.tls}
                            onChange={(value) => onChange('imap.tls', value)}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            width={50}
                            height={25}
                            onColor='#E87721'
                            onHandleColor='#fff'
                          />
                          <label>{lang('channels_field_tls')}</label>
                        </div>
                        <div className='imap-seccion-input-two'>
                          <TextInputField
                            label={lang('channels_field_smtp_host')}
                            value={state.smtp.host}
                            placeholder={lang('channels_field_smtp_host_placeholder')}
                            onChange={(value) => onChange('smtp.host', value.replace(/\s/g, ''))}
                            errorMessage={stateError.smtp.host}
                          />

                          <TextInputField
                            label={lang('channels_field_port')}
                            value={state.smtp.port}
                            placeholder={lang('channels_field_smtp_port_placeholder')}
                            onChange={(value) => onChange('smtp.port', value.replace(/\s/g, ''))}
                            type='number'
                            errorMessage={stateError.smtp.port}
                          />
                        </div>
                        <div className='field-switch'>
                          <ReactSwitch
                            checked={state.smtp.tls}
                            onChange={(value) => onChange('smtp.tls', value)}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            width={50}
                            height={25}
                            onColor='#E87721'
                            onHandleColor='#fff'
                          />
                          <label>{lang('channels_field_tls')}</label>
                        </div>
                      </div>
                  }
                </div>
              }

              <div className='seccion-buttons'>
                <Button className={'button-back'} value={lang('dashboard_previous')} onClick={closeModal} />
                {isImapVerified && <Button secondary className={''} value={lang('dashboard_continue')} onClick={onSave} isSubmitting={isSubmitting} />}
                {!isImapVerified && <Button secondary className={'btn-imap-verification'} value={lang('dashboard_test-connection')} onClick={validateImap}/>}
              </div>

            </div>
            :
            null
        }
        isOpen={isOpenModalNormal}
        toggle={closeModal}
        showClose={true}
      />
      <ImapValidationModal
        isOpen={isOpenVerificationModal}
        isLoading={isSubmitting}
        toggle={() => {
          setIsOpenVerificationModal(!isOpenVerificationModal)
          setChanges({ imap: [], smtp: [] })
          cleanErrorState()
        }}
        typeMessage={typeMessage}
        changes={changes}
        errors={stateError}
        applyChanges={applyChanges}
        onSave={onSave}
      />
    </>
  )
}

export default ImapModal
